import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListCustomerCell } from './charge-point-list-customer.cell';
import { ChargePointListCustomerHeader } from './charge-point-list-customer.header';

export const ChargePointListCustomerColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['customer']
> = {
  enableSorting: false,
  header: ChargePointListCustomerHeader,
  cell: ChargePointListCustomerCell,
  meta: { maxWidth: '140px' },
};
